export default __webpack_public_path__ + "static/students2-b7d3c4114cce34c411b2d1b0e1310723.jpg";